import { search } from "algolia-instant-search";
const { stats, configure } = instantsearch.widgets;

const PROD_STORE = "fbgure-nn.myshopify.com";

if (!customElements.get("main-collection")) {
  class MainCollection extends HTMLElement {
    collectionId = this.dataset.collectionId;
    collectionHandle = this.dataset.collectionHandle;

    constructor() {
      super();
      if (!this.collectionId) {
        window.location.href = "/collections/all-products";
      }
    }

    async connectedCallback() {
      if (window.Shopify.shop !== PROD_STORE && this.collectionHandle) {
        const prodId = await this.resolveProdCollectionId(this.collectionHandle);
        if (prodId) this.collectionId = prodId;
      }

      document
        .querySelectorAll(".collection-description-content iframe")
        .forEach((iframe) => {
          if (!iframe.hasAttribute("loading"))
            iframe.setAttribute("loading", "lazy");
        });

      this.initializeSearch();

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => search.start());
      } else {
        search.start();
      }
    }

    async resolveProdCollectionId(handle) {
      try {
        const mapUrl = this.dataset.collectionMapUrl;
        if (!mapUrl) return null;
        const res = await fetch(mapUrl);
        if (!res.ok) return null;
        const map = await res.json();
        return map[handle] || null;
      } catch {
        return null;
      }
    }

    initializeSearch() {
      search.addWidgets([this.statsWidget, this.configureWidget]);
    }

    get statsWidget() {
      return stats({
        container: "#stats",
        templates: {
          text(data) {
            const { nbHits, page, hitsPerPage } = data;

            if (nbHits === 0) return "No results";

            const first = page * hitsPerPage + 1;
            const last = Math.min((page + 1) * hitsPerPage, nbHits);

            return `${nbHits.toLocaleString()} results (showing ${first}-${last})`;
          },
        },
      });
    }

    get configureWidget() {
      return configure({
        filters: `collection_ids:${this.collectionId} AND status:ACTIVE AND NOT metafield_seo_hidden:1`,
        distinct: true,
        maxValuesPerFacet: 1000,
        attributesToRetrieve: [
          "handle",
          "title",
          "product_title",
          "featured_image",
          "images",
          "price",
          "compare_at_price",
          "sku",
          "variants",
          "objectID",
          "product_id",
          "id",
          "variant_id",
          "metafield_quick_ship",
          "metafield_expert_pick",
          "metafield_reviews_average",
          "metafield_reviews_count",
        ],
      });
    }
  }
  customElements.define("main-collection", MainCollection);
}
